import { FormElementConfig, FormFieldSpec, StepSpec, WORKFLOW_SPEC_SCHEMA_VERSION, WorkflowSpec } from './WorkflowSpec';

export const emptyWorkflowSpec = (): WorkflowSpec => ({
  schemaVersion: WORKFLOW_SPEC_SCHEMA_VERSION,
  meta: {
    title: '',
    description: '',
    workflowId: 'new-workflow',
    version: 1,
    tags: [],
  },
  instantiation: {
    triggerDescription: '',
    allowConcurrentInstances: false,
  },
  resolution: {
    autoComplete: [],
    autoCancel: [],
    manualComplete: { allowed: 'always' },
    manualCancel: { allowed: 'never' },
    manualClosureReasons: [],
  },
  steps: [],
});

export const emptyStep = (id: string): StepSpec => ({
  id,
  title: '',
  description: '',
  variant: 'generic',
  variantConfig: { kind: 'generic' },
  assignment: { kind: 'loanPointOfContact' },
  activation: {
    autoActivate: false,
    triggeredBy: [],
    triggerCombinator: 'all',
    formValueGates: [],
    additionalConditionPlainEnglish: null,
    manualActivation: { allowed: 'always' },
  },
  completion: {
    autoCompleteOnFormSubmit: false,
    autoCompletePlainEnglish: '',
    formValueGates: [],
    manualCompletion: { allowed: 'always' },
  },
  skip: {
    autoSkipPlainEnglish: null,
    manualSkip: { allowed: 'never' },
  },
  fail: {
    autoFailPlainEnglish: null,
    manualFail: { allowed: 'never' },
  },
  visibility: { isVisiblePlainEnglish: null },
  due: { kind: 'never' },
  retry: { kind: 'never' },
  dataCollection: [],
  displayInfo: [],
  onActivateActions: [],
  onCompleteActions: [],
  inlineActions: [],
  createTask: { kind: 'always' },
  editAfterCompletion: { allowed: 'never' },
  supportNotes: true,
});

export const emptyFormField = (key: string, element: FormElementConfig): FormFieldSpec => ({
  key,
  label: '',
  required: false,
  multiValued: false,
  element,
});

export const defaultElementForKind = (kind: FormElementConfig['kind']): FormElementConfig => {
  switch (kind) {
    case 'textInput':
      return { kind: 'textInput', validValues: null };
    case 'textArea':
      return { kind: 'textArea', validValues: null };
    case 'select':
      return { kind: 'select', validValues: [], typeaheadSearch: false };
    case 'radio':
      return { kind: 'radio', validValues: [] };
    case 'boolean':
      return { kind: 'boolean' };
    case 'numberInput':
      return { kind: 'numberInput', min: null, max: null };
    case 'currencyInput':
      return { kind: 'currencyInput', min: null, max: null };
    case 'email':
      return { kind: 'email' };
    case 'phoneNumber':
      return { kind: 'phoneNumber' };
    case 'plainDate':
      return { kind: 'plainDate' };
    case 'borrowerSelect':
      return { kind: 'borrowerSelect' };
    case 'group':
      return { kind: 'group', children: [emptyFormField('field1', { kind: 'textInput', validValues: null })] };
    case 'presentationOnlyMarkdown':
      return { kind: 'presentationOnlyMarkdown', markdownContent: '' };
  }
};
